import clsx from 'clsx'
import React from 'react'

import { useNode } from '@craftjs/core'
import { Button as LibraryButton } from '@wartek-id/button'

import { trackWidgetClick } from './utils'

import { Anchor } from 'components/Anchor'

import type { IButton } from './typings'

const Button = ({ label, color, url, trackerWidgetData }: IButton) => {
  const {
    connectors: { connect, drag },
    isSelected,
  } = useNode((node) => ({
    isSelected: node.events.selected,
  }))

  return (
    <Anchor href={url}>
      <LibraryButton
        ref={(ref) => connect(drag(ref!))}
        className={clsx(
          'widget-component',
          'mb-2 last:mb-0',
          isSelected && 'widget-component__selected'
        )}
        fullWidth
        color={color}
        as="a"
        href={url}
        onClick={() =>
          trackWidgetClick({
            ...trackerWidgetData,
            widgetValue: {
              ...trackerWidgetData.widgetValue,
              url,
              label,
            },
          })
        }
      >
        {label}
      </LibraryButton>
    </Anchor>
  )
}

export default Button
